import { Component, input, InputSignal, signal, WritableSignal, inject } from '@angular/core'
import { TranslatePipe } from '@ngx-translate/core'
import { TuiDropdown, TuiDropdownManual } from '@taiga-ui/core'
import { OrderInterface } from '@modules/orders-module/interfaces/order.interface'
import { ChangeOrderComponent } from '../../../actions/change-order/change-order.component'
import { DropdownVariantEnum } from '@shared/enums/dropdown-variant.enum'
import { OrderInfoCardComponent } from '../../../actions/order-info-card/order-info-card.component'
import { CancelOrderComponent } from '@shared/components/trading/orders/orders-stocks/tables/actions/cancel-order/cancel-order.component'
import { ClickOutsideDirective } from '@shared/directives/click-outside.directive'
import { StocksOrdersHelperService } from '@modules/stocks-module/orders/services/stocks-orders-helper.service'
import { ButtonComponent } from '@shared/components/ui-kit/button/button.component'

@Component({
	selector: 'app-opened-orders-actions',
	templateUrl: './opened-orders-actions.component.html',
	styleUrl: './opened-orders-actions.component.scss',
	imports: [
		TranslatePipe,
		CancelOrderComponent,
		TuiDropdown,
		TuiDropdownManual,
		ChangeOrderComponent,
		OrderInfoCardComponent,
		ClickOutsideDirective,
		ButtonComponent,
	],
})
export class OpenedOrdersActionsComponent {
	protected readonly dropdownVariantEnum: typeof DropdownVariantEnum = DropdownVariantEnum

	public order: InputSignal<OrderInterface | null> = input<OrderInterface | null>(null)

	private readonly _ordersStocksHelperService: StocksOrdersHelperService =
		inject<StocksOrdersHelperService>(StocksOrdersHelperService)

	protected openedDropdown: WritableSignal<DropdownVariantEnum | null> = signal(null)

	get checkCanEdit(): boolean {
		const order: OrderInterface | null = this.order()
		if (!order) return false

		return this._ordersStocksHelperService.checkCanEdit(order)
	}

	get checkCanCancel(): boolean {
		const order: OrderInterface | null = this.order()
		if (!order) return false

		return this._ordersStocksHelperService.checkCanCancel(order)
	}
	protected toggleDropdown(dropdown: DropdownVariantEnum | null): void {
		if (this.openedDropdown() === dropdown) {
			this.openedDropdown.set(null)
		} else {
			this.openedDropdown.set(dropdown)
		}
	}

	protected onClickOutside(): void {
		this.openedDropdown.set(null)
	}
}
